import { render } from "./MainMenuItem.vue?vue&type=template&id=4de0f1ff&scoped=true&ts=true"
import script from "./MainMenuItem.vue?vue&type=script&lang=ts"
export * from "./MainMenuItem.vue?vue&type=script&lang=ts"

import "./main-menu.scss?vue&type=style&index=0&id=4de0f1ff&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de0f1ff"]])

export default __exports__